import { gql } from '@apollo/client';

export const GET_ACTIVITY = gql`
  query getActivity($id: Int!) {
    activity(id: $id) {
      id
      subject
      description
      startDate
      dueDate
      state
      estimatedTimeToComplete
      actualTimeToComplete
      completedDate
      tags {
        id
        name
        displayColour
      }
      assignedUsers {
        id
        firstName
        lastName
      }
      ccRecipients {
        id
        firstName
        lastName
      }
      campaign {
        id
        name
      }
      assignedStores {
        id
        name
      }
      assignedStores {
        id
        name
      }
      steps {
        id
        subject
        description
        startDate
        dueDate
        estimatedTimeToComplete
        actualTimeToComplete
        completedDate
        requiresReview
        isRequired
        sortOrder
        question {
          id
          questionDetail
          type
          options
          answer
          isMultiple
          questionChoices {
            id
            label
            value
            pillarScore
            sortOrder
          }
        }
        assignedUser {
          id
          firstName
          lastName
        }
        media {
          id
          signedUrl
          fileType
          comments {
            id
            body
            user {
              id
              firstName
              lastName
            }
          }
        }
      }
    }
  }
`;
